import * as React from "react";
import { Image, tokens, makeStyles } from "@fluentui/react-components";

export interface HeaderProps {
  title: string;
  logo: string;
  message: string;
}

const useStyles = makeStyles({
  welcome__header: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingBottom: "20px",
    paddingTop: "20px",
    backgroundColor: tokens.colorBrandBackground,
    borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
    boxShadow: tokens.shadow4,
  },
  message: {
    fontSize: tokens.fontSizeBase600,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForegroundInverted,
    marginTop: "12px",
  },
  logo: {
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: "50%",
    padding: "8px",
    boxShadow: tokens.shadow8,
  }
});

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { title, logo, message } = props;
  const styles = useStyles();

  return (
    <section className={styles.welcome__header}>
      <div className={styles.logo}>
        <Image width="48" height="48" src={logo} alt={title} />
      </div>
      <h1 className={styles.message}>{message}</h1>
    </section>
  );
};

export default Header;
